<template>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m5.5 3.336 3-.295V1A.5.5 0 0 0 8 .5H6a.5.5 0 0 0-.5.5v2.336zM5.553 21.224A.512.512 0 0 1 5.5 21v-8.336l3 .295V21a.512.512 0 0 1-.053.224l-1 2a.5.5 0 0 1-.894 0l-1-2z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="m19.968 12.609 3.075-4a1 1 0 0 0 0-1.218l-3.075-4A1 1 0 0 0 19.175 3c-.017 0-.034.001-.05.003a.659.659 0 0 1-.05.002L1.65 4.719a1 1 0 0 0-.879 1.209L1.224 8l-.453 2.072a1 1 0 0 0 .88 1.209l17.424 1.714c.035.005.068.005.1.005a1 1 0 0 0 .793-.391zM6.722 6.084a.5.5 0 1 1 .556.832.5.5 0 0 1-.556-.832zm0 3a.5.5 0 1 1 .556.832.5.5 0 0 1-.556-.832z"
        />
    </svg>
</template>
